<template>
  <ContentBlock style="width: 100%;">
    <template #title>
      <div class="d-flex align-items-center justify-content-between">
        <FormTitle :title="title" :indent="false" />
        <a-button
          size="large"
          @click="details"
        >
          <span class="px-2">Details</span>
        </a-button>
      </div>
    </template>
    <template #content>
      <div class="d-flex justify-content-center w-full">
        <div
          v-if="loading"
          class="d-flex align-items-center justify-content-center w-full h-full"
          style="min-height: 400px;"
        >
          <a-icon type="loading" style="font-size: 70px; color: #1890ff;" />
        </div>
        <div v-else-if="!hasItems" class="d-flex align-items-center justify-content-center w-full h-full" style="min-height: 400px;">
          <Empty>
            <span v-if="emptyDesc" slot="description" class="text-default">{{ emptyDesc }}</span>
          </Empty>
        </div>
        <Diagram v-else :items="diagramItems" @legendClick="legendClick" @chartClick="chartClick" />
      </div>
    </template>
  </ContentBlock>
</template>

<script>
import ContentBlock from '@/components/main/contentBlock'
import FormTitle from '@/components/custom/form/FormTitle.vue'
import Diagram from '@/views/apps/referral-program/components/Diagram.vue'
import { Empty } from 'ant-design-vue'

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    emptyDesc: {
      type: String,
      default: '',
    },
    diagramItems: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ContentBlock,
    FormTitle,
    Diagram,
    Empty,
  },
  computed: {
    hasItems() {
      return !!this.diagramItems?.length
    },
  },
  methods: {
    details() {
      this.$emit('details')
    },
    legendClick(param) {
      this.$emit('legendClick', param)
    },
    chartClick(param) {
      this.$emit('chartClick', param)
    },
  },
}
</script>
